import styled from 'styled-components';
import { useApp } from '../../context/AppContext';

const Wrap = styled.div`
  position: fixed; top: 16px; left: 16px; z-index: 10;
  background: #0b1c2b; color: #f0d6ef; padding: 10px 14px;
  border-radius: 14px; font-weight: 700; box-shadow: 0 6px 20px rgba(0,0,0,.25);
`;

export default function ProgressBadge() {
  const { state } = useApp();
  if (!state.total) return null;
  return (
    <Wrap>ענית {state.answeredCount} / {state.total}</Wrap>
  );
}
